// Raw calls to the Worker API. Thin wrappers; offline handling lives in store.ts.
import type { Profile, SessionRecord } from "../data/schema";

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
  });
  if (!res.ok) throw new Error(`${res.status} ${await res.text()}`);
  return (await res.json()) as T;
}

export const api = {
  profiles: () => req<Profile[]>("/api/profiles"),
  putProfile: (p: Profile) =>
    req<{ ok: true }>(`/api/profiles/${p.id}`, {
      method: "PUT",
      body: JSON.stringify(p),
    }),
  sessions: (profileId: string, limit = 60) =>
    req<SessionRecord[]>(
      `/api/sessions?profileId=${encodeURIComponent(profileId)}&limit=${limit}`
    ),
  postSession: (s: SessionRecord) =>
    req<{ ok: true }>("/api/sessions", {
      method: "POST",
      body: JSON.stringify(s),
    }),
  results: (profileId: string, metric?: string) =>
    req<Array<{ drill_id: string; metric: string; value: number; recorded_at: string }>>(
      `/api/results?profileId=${encodeURIComponent(profileId)}${
        metric ? `&metric=${encodeURIComponent(metric)}` : ""
      }`
    ),
};
